export var confirmLeave = "We're still processing your cart. Are you sure you want to leave?";